import { css } from '@emotion/react'
import { theme } from '@app/styles/theme'

const triggerStyles = css`
  cursor: help;
  position: relative;
  color: ${theme.palette.primary.main};

  text-decoration-line: underline;
  text-decoration-style: dashed;
  text-underline-offset: 3px;

  font-weight: 500;

  transition: all 0.15s ease;

  &:hover {
    background: ${theme.palette.primary.main}10;
    border-radius: 4px;
  }

  &:after {
    content: ' ⓘ';
    font-size: 0.75em;
    opacity: 0.7;
  }
`

const popoverStyles = css`
  width: 520px;
  max-width: min(520px, calc(100vw - 32px));
  border-bottom: 3px solid ${theme.palette.primary.main};
  border-radius: 10px;
`

const contentGridStyles = css`
  display: grid;
  grid-template-columns: 140px 1fr;
  column-gap: 24px;
  row-gap: 14px;
  align-items: start;
`

const termStyles = css`
  color: ${theme.palette.primary.main};
  font-weight: 700;
  font-size: 16px;
  line-height: 1.2;
`

const definitionStyles = css`
  color: ${theme.palette.text.primary};
  font-size: 14px;
  line-height: 1.6;
`

const footerWrapperStyles = css`
  grid-column: 1 / -1;
  justify-self: end;
`

const footerLinkStyles = css`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 6px 10px;
  border-radius: 6px;

  background: ${theme.palette.primary.main}10;
  color: ${theme.palette.primary.main};

  font-size: 13px;
  font-weight: 600;

  text-decoration: none;

  transition: all 0.15s ease;

  &:hover {
    background: ${theme.palette.primary.main}20;
    text-decoration: none;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`
export {
  triggerStyles,
  popoverStyles,
  contentGridStyles,
  termStyles,
  definitionStyles,
  footerWrapperStyles,
  footerLinkStyles,
}
